import { mapActions, mapGetters, mapState } from 'vuex';
import accountDesktopHeader from '@/components/account/account-desktop-header/account-desktop-header.vue';
import contentHeader from '@/components/generics/content-header/content-header.vue';
import deposit from '@/components/wallet/deposit/deposit.vue';
import profile from '@/components/account/profile/profile.vue';
import tabs from '@/components/generics/tabs/tabs.vue';
import withdraw from '@/components/wallet/withdraw/withdraw.vue';
import accountVerifyMixin from '@/mixins/accountVerify';
import alertBox from '@/components/generics/alert-box/alert-box.vue';
import { MODALS } from '../app/app-modals/app-modals'

const TAB_DEPOSIT = 'deposit';
const TAB_WITHDRAW = 'withdraw';

export default {
  mixins: [
    accountVerifyMixin,
  ],
  components: {
    accountDesktopHeader,
    alertBox,
    contentHeader,
    deposit,
    profile,
    tabs,
    withdraw,
  },
  data() {
    return {
      ready: false,
      activeTab: '',
    };
  },
  metaInfo() {
    return {
      title: 'Wallet',
    };
  },
  computed: {
    ...mapGetters('app', ['isLayoutDesktop', 'isLayoutMobile', 'hasMaintenance', 'isShutdownModeOn']),
    ...mapState('user', ['userData']),
    tabs() {
      if (this.isShutdownModeOn) {
        return [
          { name: TAB_WITHDRAW, title: 'Withdraw' },
        ];
      }
      return [
        { name: TAB_DEPOSIT, title: 'Deposit' },
        { name: TAB_WITHDRAW, title: 'Withdraw' },
      ]
    },
    gridRowModifier() {
      return {
        row: this.isLayoutMobile,
        'row-x': !this.isLayoutMobile,
      };
    },
    showDepositTab() {
      return this.activeTab === TAB_DEPOSIT;
    },
    showWithdrawTab() {
      return this.activeTab === TAB_WITHDRAW;
    },
    mobilePageTitle() {
      return this.isShutdownModeOn ? 'Wallet - Withdrawal' : 'Wallet';
    },
  },
  methods: {
    ...mapActions('popup', ['setCurrentPopup']),
    tabChange(name) {
      this.activeTab = name;
      if (this.isLayoutDesktop) {
        this.$router.push({
          name: 'wallet',
          query: {
            ...this.$route.query,
            tabId: this.activeTab,
          },
        });
      }
    },
  },
  created() {
    if (!this.hasUserClassicEnabled) {
      this.setCurrentPopup(MODALS.ACCOUNT_ENABLE_CLASSIC);
    } else if (!this.isUserVerified) {
      this.showAccountVerifyPopup();
    }
    if (this.isShutdownModeOn) {
      this.activeTab = TAB_WITHDRAW;
    }
    if (this.$route.query.tabId && this.isLayoutDesktop) {
      this.activeTab = this.$route.query.tabId;
    }
    this.ready = true;
  },
};



// WEBPACK FOOTER //
// ./src/components/wallet/wallet.js